import type React from "react"

import type { MapNode as MapNodeType, NodeIconConfig } from "@/types"
import { px2rem } from "@/utils/adaptFont"

import styles from "./index.module.scss"

type NodeState = "current" | "reachable" | "visited" | "locked"

interface Props {
    node: MapNodeType
    state: NodeState
    iconConfig?: NodeIconConfig
    onClick?: (nodeId: string) => void
}

export const MapNodeComponent: React.FC<Props> = ({
    node,
    state,
    iconConfig,
    onClick,
}) => {
    const isEndCurrent = node.type === "end" && state === "current"
    const clickable = state === "reachable" || isEndCurrent

    const cssVars = {
        "--node-x": px2rem(node.position.x),
        "--node-y": px2rem(node.position.y),
        "--node-w": px2rem(iconConfig?.width ?? 70),
        "--node-h": px2rem(iconConfig?.height ?? 70),
    } as React.CSSProperties

    const handleClick = () => {
        if (clickable && onClick) {
            onClick(node.id)
        }
    }

    return (
        <button
            className={styles.node}
            data-state={state}
            data-node-id={node.id}
            data-end-current={isEndCurrent || undefined}
            style={cssVars}
            type="button"
            onClick={handleClick}
            disabled={!clickable}
        >
            {iconConfig && (
                <img
                    className={styles.highlightIcon}
                    src={iconConfig.highlightIcon}
                    alt=""
                    draggable={false}
                    data-visible={clickable || undefined}
                />
            )}
        </button>
    )
}
